import { render, staticRenderFns } from "./OrkStock.html?vue&type=template&id=1d4a93c6&"
import script from "./OrkStock.vue?vue&type=script&lang=js&"
export * from "./OrkStock.vue?vue&type=script&lang=js&"
import style0 from "./OrkStock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports